"use strict";

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ConstraintStrength;

(function (ConstraintStrength) {
  ConstraintStrength[ConstraintStrength["HARD"] = 1] = "HARD";
  ConstraintStrength[ConstraintStrength["STRONG"] = 2] = "STRONG";
  ConstraintStrength[ConstraintStrength["MEDIUM"] = 3] = "MEDIUM";
  ConstraintStrength[ConstraintStrength["WEAK"] = 4] = "WEAK";
  ConstraintStrength[ConstraintStrength["WEAKER"] = 5] = "WEAKER";
})(ConstraintStrength = exports.ConstraintStrength || (exports.ConstraintStrength = {}));

var ConstraintPlugin = function ConstraintPlugin() {
  _classCallCheck(this, ConstraintPlugin);
};

exports.ConstraintPlugin = ConstraintPlugin;

var ConstraintSolver =
/*#__PURE__*/
function () {
  function ConstraintSolver() {
    _classCallCheck(this, ConstraintSolver);

    this.plugins = [];
  } // /** Solve the constraints asynchronously */
  // public abstract solveAsync(callback: (finish: boolean) => void): void;
  // /** Stop the async solve */
  // public abstract solveAsyncStop(): void;
  // Below are general helper functions

  /** Get attributes */


  _createClass(ConstraintSolver, [{
    key: "attrs",
    value: function attrs(map, name) {
      var _this = this;

      return name.map(function (n) {
        return _this.attr(map, n);
      });
    }
    /** Get a linear value */

  }, {
    key: "getLinear",
    value: function getLinear() {
      var s = 0;

      for (var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++) {
        items[_key] = arguments[_key];
      }

      for (var _i = 0, _items = items; _i < _items.length; _i++) {
        var v = _items[_i];
        s += v[0] * this.getValue(v[1]);
      }

      return s;
    }
    /** Add a constraint that enfoces a = b */

  }, {
    key: "addEquals",
    value: function addEquals(strength, a, b) {
      this.addLinear(strength, 0, [[1, a], [-1, b]]);
    }
    /** Add a constraint that enfoces a = value */

  }, {
    key: "addEqualToConstant",
    value: function addEqualToConstant(strength, a, value) {
      this.addLinear(strength, value, [[-1, a]]);
    }
  }, {
    key: "addPlugin",
    value: function addPlugin(plugin) {
      this.plugins.push(plugin);
    }
  }, {
    key: "applyPlugins",
    value: function applyPlugins() {
      this.plugins.forEach(function (p) {
        return p.apply();
      });
    }
  }]);

  return ConstraintSolver;
}();

exports.ConstraintSolver = ConstraintSolver;